import { Input, Slide, StarsButton, Translation, Validation } from '@ps/web-shared-components';
// import { Input, StarsButton, Translation, Validation } from '@ps/web-shared-components';
import { numberRange, numbersOnly } from '@ps/web-shared-validators';
import classNames from 'clsx';
import React from 'react';
import { useField } from 'react-final-form';

import { Error } from '@swf/account';

import {
  TXTCLI_Please_enter_a_number_between__ELL,
  TXTCLI_hours,
  TXTWCL_Confirm_N0_hours,
  TXTWCL_Weekly_Poker_Time_Limit,
  TXTWCL_Whole_numbers_onlyX_No_decimal_ELL
} from './PokerSlider.messages.json';
import styles from './PokerSlider.scss';

enum PokerTimeLimits {
  Min = 2,
  Max = 167
}

export const pokerSliderFieldName = 'playingTimeWeekly';

const PokerSlider: React.FC = () => {
  const {
    input: { value: pokerHoursTimeLimit }
  } = useField(pokerSliderFieldName, {
    subscription: { value: true },
    initialValue: PokerTimeLimits.Min
  });

  return (
    <>
      <div>
        <Translation tagName="strong" {...TXTWCL_Weekly_Poker_Time_Limit} />
      </div>
      <div className={styles.wrapper}>
        <div className={classNames(styles.inputWrapper)}>
          <Input
            hideLabel
            label="Hour"
            maxLength={3}
            numericKeyboard
            id={pokerSliderFieldName}
            showValidationTick={false}
            value={PokerTimeLimits.Min.toString()}
            parse={(value: string) => value.replace(/[^\d]/g, '')}
            validators={[
              numbersOnly(TXTWCL_Whole_numbers_onlyX_No_decimal_ELL, true),
              numberRange(
                PokerTimeLimits.Min,
                PokerTimeLimits.Max,
                {
                  ...TXTCLI_Please_enter_a_number_between__ELL,
                  values: { 0: PokerTimeLimits.Min, 1: PokerTimeLimits.Max }
                },
                true
              )
            ]}
            validationVariant={Validation.Invisible}
          />
          <strong className={styles.inputHours}>
            <Translation {...TXTCLI_hours} />
          </strong>
        </div>
        <Error name={pokerSliderFieldName} />
        <Slide
          id={pokerSliderFieldName}
          min={PokerTimeLimits.Min}
          max={PokerTimeLimits.Max}
          valueLabelDisplay="auto"
          marks={[
            { value: PokerTimeLimits.Min, label: PokerTimeLimits.Min },
            { value: PokerTimeLimits.Max, label: PokerTimeLimits.Max }
          ]}
        />
        <StarsButton
          type="submit"
          className={styles.button}
          values={{ 0: pokerHoursTimeLimit }}
          translation={TXTWCL_Confirm_N0_hours}
        />
      </div>
    </>
  );
};

export default PokerSlider;
